<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="footer-content">
        <div class="footer-copyright">
          <span class="footer-year">2026</span>
          <span class="footer-separator">©</span>
          <span class="footer-brand">CEX</span>
        </div>
        <div class="footer-right">
          <span class="footer-crafted">Crafted with</span>
          <i class="ri-heart-fill footer-heart"></i>
          <span class="footer-by">by Quelinka</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
.footer-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
}

.footer-copyright {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
  flex-shrink: 0;
  
  .footer-year {
    font-weight: 600;
    color: #558b2f;
  }
  
  .footer-separator {
    color: #6ea637;
    font-weight: 500;
  }
  
  .footer-brand {
    font-weight: 700;
    color: #6ea637;
    letter-spacing: 1px;
  }
}

.footer-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
  flex-shrink: 0;
  
  .footer-crafted {
    color: #5a6c5d;
  }
  
  .footer-heart {
    color: #ef5350;
    animation: heartbeat 1.5s ease-in-out infinite;
  }
  
  .footer-by {
    color: #6ea637;
    font-weight: 500;
  }
}

@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
</style>